/**
 * Shared Tailwind classes for controls that are hidden until hover on desktop.
 *
 * Such controls MUST also appear on coarse-pointer (touch) devices, which have
 * no hover state — otherwise the control is unreachable in the PWA on mobile
 * (the original "copy/edit buttons don't show on PWA" bug). `pointer-coarse:`
 * maps to `@media (pointer: coarse)`.
 *
 * This is the single source of truth for the base/hover/touch core. Callers
 * compose their own focus-reveal variant on top, because that differs by
 * element semantics:
 *   - the focusable control itself  -> `focus:opacity-100`
 *   - a container holding the control -> `focus-within:opacity-100`
 *   - a `group` wrapper around it     -> `group-focus-within:opacity-100`
 */
export const REVEAL_ON_HOVER =
  'opacity-0 transition-opacity group-hover:opacity-100 pointer-coarse:opacity-100';
